(function () {
  if (window.TRVX) return;
  var cfg = window.TRVX_CFG || {};
  var root = (cfg.root || '/').replace(/\/$/, '');
  var d2 = cfg.d2 || 15, d3 = cfg.d3 || 20;
  var drawer = document.getElementById('txc');
  var html = document.documentElement;

  function commas(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return (cfg.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return commas(parts[0]);
      if (k === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return commas(parts[0]) + '.' + parts[1];
    });
  }
  function q(s) { return drawer && drawer.querySelector(s); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function img(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  function open() { if (!drawer) return; html.classList.add('txc-open'); drawer.setAttribute('aria-hidden', 'false'); var c = q('.txc__close'); if (c) c.focus({ preventScroll: true }); }
  function close() { if (!drawer) return; html.classList.remove('txc-open'); drawer.setAttribute('aria-hidden', 'true'); }

  function bubbles(n) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (e) { e.textContent = n; e.classList.toggle('hidden', !n); });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', !n); });
  }

  function render(cart) {
    if (!drawer) return;
    var body = q('[data-txc-body]'), foot = q('[data-txc-foot]'), prog = q('[data-txc-progress]');
    bubbles(cart.item_count);
    var n = cart.item_count;
    q('[data-txc-fill]').style.width = (n <= 0 ? 0 : n === 1 ? 14 : n === 2 ? 56 : 100) + '%';
    drawer.querySelectorAll('.txc__steps span').forEach(function (s) { s.classList.toggle('on', n >= +s.dataset.step); });
    q('[data-txc-msg]').innerHTML = n <= 0 ? 'Bundle sets and save up to ' + d3 + '%' :
      n === 1 ? 'Add <b>1 more set</b> to save <b>' + d2 + '%</b>' :
      n === 2 ? 'You\'re saving <b>' + d2 + '%</b>. Add <b>1 more</b> to save <b>' + d3 + '%</b>' :
      'Best bundle unlocked: <b>' + d3 + '% off</b>';

    if (!cart.items.length) {
      body.innerHTML = '<div class="txc__empty"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2.5l2 11h10l2-8H7"/><circle cx="9" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/></svg><p><b>Your cart is empty</b></p><p>Add a set of lights to get started.</p><button type="button" class="tx-btn" data-txc-close style="margin-top:18px">Continue shopping</button></div>';
      foot.hidden = true; prog.hidden = true; return;
    }
    foot.hidden = false; prog.hidden = false;

    var h = '';
    cart.items.forEach(function (it, i) {
      var o = it.original_line_price, f = it.final_line_price;
      h += '<div class="txc__item"><img src="' + img(it.image, 160) + '" alt="" width="76" height="76" loading="lazy">' +
        '<div><p class="txc__name">' + esc(it.product_title) + (it.variant_title ? '<br><small style="font-weight:400;color:#5E6475">' + esc(it.variant_title) + '</small>' : '') + '</p>' +
        '<div class="txc__qty"><button type="button" data-txc-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-txc-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="txc__price">' + (o > f ? '<s>' + money(o) + '</s>' : '') + money(f) + (o > f ? '<span class="txc__save">Saved ' + money(o - f) + '</span>' : '') + '</div></div>';
    });
    var first = cart.items[0];
    if (n < 3 && first) {
      var nq = n + 1, pct = nq >= 3 ? d3 : d2;
      var perUnit = Math.floor(first.original_price * pct / 100);
      var extra = (first.original_price - perUnit) * nq - first.final_line_price;
      h += '<div class="txc__upsell"><img src="' + img(first.image, 120) + '" alt="" width="56" height="56" loading="lazy"><div>' +
        '<p><b>Add one more set</b> and save ' + pct + '% on your bundle.</p>' +
        '<button type="button" data-txc-qty="1" data-q="' + (first.quantity + 1) + '">Add 1 more set' + (extra > 0 ? ' · +' + money(extra) : '') + '</button></div></div>';
    }
    body.innerHTML = h;
    var saved = cart.original_total_price - cart.total_price;
    q('[data-txc-saverow]').hidden = saved <= 0;
    q('[data-txc-save]').textContent = '−' + money(saved);
    q('[data-txc-total]').textContent = money(cart.total_price);
  }

  function req(url, data) {
    drawer && drawer.classList.add('txc__loading');
    return fetch(root + url, { method: data ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: data ? JSON.stringify(data) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .finally(function () { drawer && drawer.classList.remove('txc__loading'); });
  }
  function refresh() { return req('/cart.js').then(render); }

  window.TRVX = {
    open: function () { if (!drawer) { window.location.href = root + '/cart'; return; } refresh(); open(); },
    close: close,
    add: function (id, qty) {
      return req('/cart/add.js', { items: [{ id: +id, quantity: +qty || 1 }] }).then(refresh).then(function () { if (drawer) open(); else window.location.href = root + '/cart'; });
    },
    money: money
  };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-txc-close]')) { e.preventDefault(); close(); return; }
    var b = t.closest('[data-txc-qty]');
    if (b) { req('/cart/change.js', { line: +b.dataset.txcQty, quantity: Math.max(0, +b.dataset.q) }).then(render); return; }
    var a = t.closest('a[href]');
    if (a && drawer && !a.closest('#txc') && /\/cart\/?$/.test(a.getAttribute('href').split('?')[0])) { e.preventDefault(); window.TRVX.open(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"]');
    if (b && drawer) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); window.TRVX.open(); }
  }, true);
})();